import styled from '@emotion/styled';
import is from '@sindresorhus/is';
import { Fragment } from 'react';
import { useDropzone } from 'react-dropzone';
import Maybe from 'true-myth/maybe';

import { CloudUploadedIcon } from './assets/CloudUploadedIcon';
import { CloudUploadIcon } from './assets/CloudUploadIcon';
import { useCompanyOnboardingStore } from './use-company-onboarding-store';

import type { FunctionComponent } from 'react';

const UploadFrame = styled.div({
    alignItems: 'center',
    background: '#f6f6f7',
    border: '1px solid #dadad8',
    borderRadius: '0.75rem',
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    justifyContent: 'center',
    padding: '0.75rem',
    textAlign: 'center',
    width: '26rem',
});

const HighlightedText = styled.p({
    color: '#fc531f',
    fontFamily: "'FT Regola Neue'",
    fontSize: '0.75rem',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '1.125rem',
    margin: 0,
});

const StyledText = styled.p({
    color: '#53565b',
    fontFamily: "'FT Regola Neue'",
    fontSize: '0.75rem',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '1.125rem',
    margin: 0,
});

const InlineContainer = styled.div({
    display: 'flex',
});

const ImageWrapper = styled.div({
    background: '#fbfbff',
    borderRadius: '0.5rem',
    boxShadow:
        '0.8px 1px 1px 0px rgba(251, 251, 255, 0.7) inset, -1px -0.8px 1px 0px rgba(251, 251, 255, 0.5) inset, 0px 3px 1px 0px rgba(80, 80, 82, 0.01), 0px 2px 1px 0px rgba(80, 80, 82, 0.05), 0px 1px 1px 0px rgba(80, 80, 82, 0.09)',
    height: '2.5rem',
    padding: '0.625rem',
    width: '2.5rem',
});

export const SingleFileUploader: FunctionComponent = () => {
    const uploadCV = useCompanyOnboardingStore((state) => state.uploadCV);
    const uploadedCV = useCompanyOnboardingStore((state) => state.uploadedCV);
    const onDrop = (acceptedFiles: File[]): void => {
        if (is.nonEmptyArray(acceptedFiles)) {
            uploadCV(Maybe.just(acceptedFiles[0]));
        }
    };

    const { getInputProps, getRootProps } = useDropzone({
        accept: { 'application/pdf': ['.pdf'] },
        maxFiles: 1,
        multiple: false,
        onDrop,
    });

    return (
        <div
            style={{ height: '100%' }}
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...getRootProps()}
        >
            {/* // eslint-disable-next-line react/jsx-props-no-spreading */}
            <input {...getInputProps()} />
            <UploadFrame>
                {uploadedCV.isJust ? (
                    <Fragment>
                        <ImageWrapper>
                            <CloudUploadedIcon />
                        </ImageWrapper>
                        <HighlightedText>{uploadedCV.value.name}</HighlightedText>
                    </Fragment>
                ) : (
                    <Fragment>
                        <ImageWrapper>
                            <CloudUploadIcon />
                        </ImageWrapper>
                        <div>
                            <InlineContainer>
                                <HighlightedText>Click to upload</HighlightedText>
                                <StyledText>or drag and drop</StyledText>
                            </InlineContainer>
                            <StyledText>PDF</StyledText>
                        </div>
                    </Fragment>
                )}
            </UploadFrame>
        </div>
    );
};
